export default __webpack_public_path__ + "08b6eb4512789ad4c00d731afe47a56d.jpg";